module.exports = __webpack_public_path__ + "images/icons_v2/values-go-4ce98f3a.svg";